module.exports = __webpack_public_path__ + "images/background/image_thumbnail/4-on-1df7dc92bb54073f5cd70a9192179a20.jpg";